<template>
  <div>
    <div class="p-box">
      <Loading v-if="gmbStoresLoading" />
      <div v-else-if="noLinked" class="p-box__body">
        <h2 class="c-pageTitle">
          {{ $t('components.RequireGmbConnect.title') }}
        </h2>
        <p>{{ $t('pages.CompaniesProducts.gmb.notice') }}</p>
        <div class="c-button c-button--left">
          <router-link
            :to="{ name: 'CompaniesGoogleOauth', params: { company_uuid: companyUuid }}"
            class="c-button__item c-button__item--primary"
          >
            {{ $t('pages.CompaniesProducts.gmb.doConnect') }}
          </router-link>
        </div>
      </div>
      <div v-else>
        <Loading v-if="loading" />
        <KkTutorial
          v-else-if="firstTimeLength.length === 0 && !queryParameter"
          :description1="$t('pages.CompaniesProducts.noProduct.notice')"
          :img-path="productsImagePath"
          :tutorial-description="$t('pages.CompaniesProducts.noProduct.description')"
          class="noProducts"
        >
          <template v-if="showMoreThanEditorAuthority" #buttonArea>
            <div class="c-button noProducts__button">
              <router-link :to="{ name: 'CompaniesProductNew', params: { company_uuid: companyUuid }}"
                           class="c-button__item c-button__item--primary"
              >
                {{ $t("pages.CompaniesProducts.noProduct.add") }}
              </router-link>
            </div>
          </template>
        </KkTutorial>
        <div v-else>
          <header class="p-box__header">
            <div class="p-filtersA">
              <div class="p-filtersA__left">
                <button @click="changeLayout()">
                  <div v-if="type==='grid'" class="displayChange">
                    <Icon name="iconList" />
                    {{ $t('pages.CompaniesProducts.displayChange.list') }}
                  </div>
                  <div v-else class="displayChange">
                    <Icon name="iconGrid" />
                    {{ $t('pages.CompaniesProducts.displayChange.grid') }}
                  </div>
                </button>
                <div class="c-buttonFilter" @click="openModal">
                  {{ $t('labels.filters') }}
                  <div class="c-buttonFilter__icon">
                    <Icon name="iconFilter" />
                  </div>
                </div>
                <div v-if="showMoreThanEditorAuthority" class="c-select">
                  <select value="" :disabled="checkProductIds.length === 0" @change="handleSelectAction($event.target.value)">
                    <option value="" disabled>{{ $t('pages.CompaniesLocationStores.bulkUpdate') }}</option>
                    <option value="bulkSet">
                      {{ $t('pages.CompaniesProducts.multiSelectOptions.set') }}
                    </option>
                    <option value="bulkDelete">
                      {{ $t('pages.CompaniesProducts.multiSelectOptions.delete') }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="p-filtersA__right">
                <form class="c-searchField" onsubmit="return false;">
                  <input
                    v-model="searchQuery"
                    :disabled="loading"
                    type="text"
                    class="searchForm"
                    :placeholder="$t('labels.search')"
                    @keydown.enter="search"
                  >
                  <Icon name="iconSearch" />
                </form>
                <div v-if="showMoreThanEditorAuthority" class="addProduct">
                  <KkButton color="primary" full :text="$t('pages.CompaniesProducts.addProduct')" :to="{ name: 'CompaniesProductNew', params: { company_uuid: companyUuid } }" />
                </div>
              </div>
            </div>
          </header>
          <div class="p-box__body">
            <template v-if="products.length === 0">
              <div v-text="$t('messages.noData')" />
            </template>
            <template v-else>
              <Grid v-if="type === 'grid'"
                    :products="products"
                    :meta="meta"
                    :checked-ids="checkProductIds"
                    :is-editable="showMoreThanEditorAuthority"
                    @change-checkbox="handleChangeProductIds"
                    @show-store-modal="showStoreModal"
              />
              <List v-if="type === 'list'"
                    :products="products"
                    :meta="meta"
                    :checked-ids="checkProductIds"
                    :is-editable="showMoreThanEditorAuthority"
                    @change-checkbox="handleChangeProductIds"
                    @handle-delete="handleDelete"
                    @show-store-modal="showStoreModal"
              />
              <div class="p-controller">
                <div class="p-controller__count">
                  <p class="p-controller__count__name">
                    {{ $t('labels.perPageCount') }}
                  </p>
                  <div class="p-controller__count__select">
                    <select :value="displayNumber" @change="changeDisplayNumber($event)">
                      <option v-for="item in 5" :key="item" :value="item * 50">{{ item * 50 }}</option>
                    </select>
                  </div>
                  <p class="p-controller__count__current">{{ startDataNumber }}-{{ endDataNumber }}</p>
                </div>
                <div class="p-controller__navi">
                  <button
                    type="button"
                    :disabled="loading || currentPage === 1"
                    class="p-controller__navi__prev"
                    @click="goPrevPage"
                  >
                    <Icon name="arrowLeft" />
                  </button>
                  <button
                    type="button"
                    :disabled="loading || currentPage >= meta.totalPages"
                    class="p-controller__navi__next"
                    @click="goNextPage"
                  >
                    <Icon name="arrowRight" />
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
        <KkFilterModal
          :is-visible="modal"
          :filter-items="filterItems"
          :form-values="formValues"
          :total-count="meta.totalCount"
          @submit="handleResetPageAndSubmit"
          @reset="handleReset"
          @change-check-box="handleChangeFilterModalCheckBox"
          @close="isShowFilterModal = false"
        />
        <KkModal :is-visible="isShowStoreModal" @change="isShowStoreModal = false">
          <div class="content__header">
            {{ $t('pages.CompaniesProducts.storeModal.title') }}
          </div>
          <div class="content__body">
            <div v-for="(storeName, index) in storeNames" :key="index" class="item">
              {{ storeName }}
            </div>
          </div>
          <div class="content__footer">
            <div class="buttonGroup">
              <div class="buttonGroup__item">
                <KkButton color="secondary" outlined :text="$t('labels.close')" @click="isShowStoreModal = false" />
              </div>
            </div>
          </div>
        </KkModal>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import productsImagePath from '../../../../../images/products/products.png'
import Loading from '../../../components/Loading'
import Grid from '../../../components/CompaniesProducts/Grid'
import List from '../../../components/CompaniesProducts/List'
import Icon from '../../../components/Icon'
import { toNumberLocaleString } from '../../../modules/localeString'
import { addAttributes } from '../../../modules/filterModalConst'
import { KkFilterModal, KkTutorial } from '../../../components/projects'
import { KkModal, KkButton } from '../../../components/base'

export default {
  name: 'CompaniesProducts',
  components: {
    Loading,
    Grid,
    List,
    Icon,
    KkFilterModal,
    KkTutorial,
    KkModal,
    KkButton
  },
  beforeRouteUpdate (to, _, next) {
    if (!Object.keys(to.query).length) {
      this.initSearch()
    }
    next()
    this.handleResetPageAndSubmit()
  },
  data() {
    return {
      currentPage: 1,
      modal: false,
      type: 'list',
      searchQuery: this.$route.query['query'] || '',
      filterItems: [],
      isShowStoreModal: false,
      storeNames: [],
      firstTimeLength: 0,
    }
  },
  computed: {
    ...mapState({
      products: state => state.companiesProducts.data,
      checkProductIds: state => state.companiesProducts.checkProductIds,
      meta: state => state.companiesProducts.meta,
      productsLoading: state => state.companiesProducts.loading,
      displayNumber: state => state.filters.displayNumber,
      formValues: state => state.companiesProducts.formValues,
      gmbStoresLoading: state => state.companiesGmbStores.loading,
      bulkOperationsLoading: state => state.companiesProductBulkOperations.loading,
      searchAttributes: state => state.companiesSearchTagGroups.data,
      searchAttributesLoading: state => state.companiesSearchTagGroups.loading,
    }),
    ...mapGetters({
      noLinked: 'companiesGmbStores/noLinked',
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    loading() {
      return this.productsLoading || this.bulkOperationsLoading || this.gmbStoresLoading || this.searchAttributesLoading
    },
    startDataNumber() {
      return (this.currentPage - 1) * this.displayNumber + 1
    },
    endDataNumber() {
      return this.startDataNumber + this.products.length - 1
    },
    productsImagePath: () => productsImagePath,
    query() {
      const payload = {
        product_category_ids: this.formValues.product_categories,
        store_uuids: this.formValues.stores,
        brand_ids: this.formValues.brands,
        franchisee_ids: this.formValues.franchisees,
        area_ids: this.formValues.areas,
        prefectures: this.formValues.prefectures,
        user_company_ids: this.formValues.user_companies,
        original_tag_group_a_tag_ids: this.formValues.original_tag_group_a,
        original_tag_group_b_tag_ids: this.formValues.original_tag_group_b,
        original_tag_group_c_tag_ids: this.formValues.original_tag_group_c,
        original_tag_group_d_tag_ids: this.formValues.original_tag_group_d,
        original_tag_group_e_tag_ids: this.formValues.original_tag_group_e,
      }

      return {
        per: this.displayNumber,
        page: this.currentPage,
        q: { title_cont: this.searchQuery },
        search: payload,
      }
    },
    queryParameter() {
      return this.$route.query['query']
    },
  },
  async created() {
    this.initCheckProducts()
    await Promise.all([
      this.readGmbStores(this.companyUuid),
      this.readProducts(this.query),
      this.readSearchAttributes({ inclusion_unset_store: true })
    ])

    if (this.noLinked) return

    this.firstTimeLength = this.products.length

    this.setFormValues(this.formInitialValues())
    this.createFilter()
  },
  methods: {
    ...mapActions({
      readProducts: 'companiesProducts/readProducts',
      readProductsForFilter: 'companiesProducts/readProductsForFilter',
      setDisplayNumber: 'filters/setDisplayNumber',
      setProductId: 'companiesProducts/setProductId',
      setProductsForBulkSet: 'companiesProducts/setProductsForBulkSet',
      deleteProduct: 'companiesProducts/deleteProduct',
      deleteProducts: 'companiesProductBulkOperations/deleteProducts',
      readGmbStores: 'companiesGmbStores/readGmbStores',
      readSearchAttributes: 'companiesSearchTagGroups/readSearchTagGroups',
    }),
    ...mapMutations({
      setFormValues: 'companiesProducts/setFormValues',
      initCheckProducts: 'companiesProducts/initCheckProducts'
    }),
    handleSubmit() {
      this.readProducts(this.query)
      this.closeModal()
    },
    handleScrollTopAndSubmit() {
      window.scrollTo({ top: 0 })
      this.handleSubmit()
    },
    handleResetPageAndSubmit() {
      this.currentPage = 1
      this.handleSubmit()
    },
    /**
     * 絞り込み条件のリセット
     * @return { Void }
     */
    handleReset() {
      this.setFormValues(this.formInitialValues())
      this.handleSubmit()
      this.modal = false
    },
    handleChangeProductIds(id) {
      this.setProductId(id)
    },
    async handleDelete(id) {
      if (confirm(this.$t('pages.CompaniesProducts.deleteConfirm'))) {
        if (await this.deleteProduct(id)) this.readProducts(this.query)
      }
    },
    search(event) {
      if (this.loading) return

      if (event.keyCode !== 13) return
      if (this.searchQuery === (this.$route.query['query'] || '')) return

      const query = { 'query': this.searchQuery || undefined }
      this.$router.push({ query: query })
    },
    openModal() { this.modal = true },
    closeModal() { this.modal = false },
    async handleSelectAction(val) {
      switch (val) {
      case 'bulkSet':
        this.setProductsForBulkSet()
        this.$router.push({
          name: 'CompaniesProductsBulkSet',
          params: { company_uuid: this.companyUuid }
        })
        return
      case 'bulkDelete':
        if (confirm(this.$t('pages.CompaniesProducts.deleteConfirm'))) {
          const payload = {
            product_ids: this.checkProductIds,
          }
          if (await this.deleteProducts(payload)){
            this.readProducts(this.query)
            this.initCheckProducts()
          }
        }
        return
      }
    },
    changeLayout() {
      if(this.type === 'list') {
        this.type = 'grid'
      } else {
        this.type = 'list'
      }
      return
    },
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
    /**
     * 表示件数の変更
     * @param  { Object } e
     * @return { Void }
     */
    changeDisplayNumber(e) {
      this.setDisplayNumber(e.target.value)
      this.handleResetPageAndSubmit()
    },
    goPrevPage() {
      --this.currentPage
      this.handleScrollTopAndSubmit()
    },
    goNextPage() {
      ++this.currentPage
      this.handleScrollTopAndSubmit()
    },
    initSearch() {
      this.searchQuery = ''
      this.currentPage = 1
    },
    /**
     * 検索条件の初期値
     * @return { Object }
     */
    formInitialValues() {
      return {
        product_categories: [],
        stores: [],
        brands: [],
        franchisees: [],
        user_companies: [],
        areas: [],
        prefectures: [],
        original_tag_group_a: [],
        original_tag_group_b: [],
        original_tag_group_c: [],
        original_tag_group_d: [],
        original_tag_group_e: []
      }
    },
    createFilter() {
      const attributes = [
        this.searchAttributes.product_categories,
        this.searchAttributes.brands,
        this.searchAttributes.areas,
        this.searchAttributes.franchisees,
        this.searchAttributes.user_companies,
      ]

      if(this.searchAttributes.original_tag_group_a) attributes.push(this.searchAttributes.original_tag_group_a)
      if(this.searchAttributes.original_tag_group_b) attributes.push(this.searchAttributes.original_tag_group_b)
      if(this.searchAttributes.original_tag_group_c) attributes.push(this.searchAttributes.original_tag_group_c)
      if(this.searchAttributes.original_tag_group_d) attributes.push(this.searchAttributes.original_tag_group_d)
      if(this.searchAttributes.original_tag_group_e) attributes.push(this.searchAttributes.original_tag_group_e)

      attributes.push(this.searchAttributes.prefectures)
      attributes.push(this.searchAttributes.stores)

      this.filterItems = attributes.map((attr) => {
        if(attr && attr.kind){
          return addAttributes(attr, attr.kind)
        }
      })
    },
    handleChangeFilterModalCheckBox({ kind, id }) {
      const newFormValues = Object.assign({}, this.formValues)

      if(newFormValues[kind].includes(id)) {
        newFormValues[kind] = newFormValues[kind].filter((_id) => _id !== id)
      } else {
        newFormValues[kind].push(id)
      }

      this.setFormValues(newFormValues)
      this.readProductsForFilter(this.query)
    },
    showStoreModal(storeNames) {
      this.storeNames = storeNames
      this.isShowStoreModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.p-filtersA__right {
  align-items: flex-start;
}
.noProducts {
  &__button {
    .c-button__item {
      margin: 0;
    }
  }
}
.linkToAddProduct {
  margin-top: 24px;
}
.displayChange {
  display: flex;
  align-items: center;
  svg {
    margin-right: 10px;
  }
}
.c-searchField {
  margin-right: 10px;
  .searchForm {
    height: 38px;
    padding: 8px 6px 8px 48px;
  }
}
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }
  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }
  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;
    .item {
      padding: 0 12px 12px;
    }
  }
  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
.buttonGroup {
  display: flex;
  flex-grow: 0;
  &__item {
    margin: 8px;
  }
}
.addProduct {
  margin-left: 8px;
  @media screen and (max-width: 768px) {
    margin-top: 16px;
    margin-left: 0;
  }
}
</style>
